import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { staffApi } from '../api/staff';
import { CreateOrUpdateAdmin } from '../types/Staff';

export const useUpdateAdminUser = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      userId,
      updatedAdmin,
    }: {
      userId: number;
      updatedAdmin: CreateOrUpdateAdmin;
    }) => staffApi.updateAdminUser(userId, updatedAdmin),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adminUsers'] });
      message.success('Usuário atualizado com sucesso');
    },
    onError: (_, variables) => {
      message.error(
        `Erro ao atualizar usuário ${variables.updatedAdmin.fullName}`
      );
    },
  });

  const { mutateAsync, isPending: isLoading, ...rest } = mutation;

  return { mutateAsync, isLoading, ...rest };
};
